import { useCallback, useEffect, useState } from 'react';
import classnames from 'classnames';

import styles from './index.module.scss';

import type { FC, MouseEventHandler } from 'react';
import type { ModalProps } from '../modal';

export interface MaskProps extends Pick<ModalProps, 'isOpen' | 'maskStyle'> {
  onClick?: MouseEventHandler<HTMLDivElement>;
}

const Mask: FC<MaskProps> = (props) => {

  const { isOpen, maskStyle } = props;

  const [isShow, setIsShow] = useState(isOpen);

  useEffect(() => {
    if (isOpen) {
      setIsShow(true);
    }
  }, [isOpen])

  const onTransitionEnd = useCallback(() => {
    if (!isOpen) {
      setIsShow(false);
    }
  }, [isOpen]);

  if (!isShow) {
    return null;
  }

  return (
    <div
      style={maskStyle}
      onTransitionEnd={onTransitionEnd}
      onClick={props.onClick}
      className={
        classnames(
          styles.web_components_modal_mask,
          {
            [styles.web_components_modal_mask_hidden]: !isOpen,
            [styles.web_components_modal_mask_show]: isOpen,
            ['web_components_modal_mask_show']: isOpen,
          }
        )
      }>
    </div>
  )
}

export default Mask;